// Material Dashboard 2 PRO React base styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";

const { background } = colors;
const { borderRadius } = borders;

const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    paper: {
      backgroundColor: `${background.card} !important`,
      backgroundImage: "none !important",
      borderRadius: borderRadius.md,
      border: "1px solid rgba(255, 255, 255, 0.12)",
    },
    list: {
      backgroundColor: background.card,
    },
    root: {
      "& .MuiPaper-root": {
        backgroundColor: `${background.card} !important`,
        backgroundImage: "none !important",
      },
    },
  },
};

export default menu;
